export interface SequenceStreamAsset {
  readonly key: string;
  readonly path: string;
  readonly width: number;
  readonly height: number;
  readonly alpha: boolean;
  readonly required: true;
}

const ROOT = 'assets/story-forest/sequence-stream';
const image = (key: string, path: string, width: number, height: number, alpha: boolean): SequenceStreamAsset => ({
  key, path: `${ROOT}/${path}`, width, height, alpha, required: true,
});

export const SEQUENCE_STREAM_ASSETS = {
  dormant: image('sequence-stream-dormant', 'backgrounds/sequence-stream-dormant.png', 1280, 720, false),
  restored: image('sequence-stream-restored', 'backgrounds/sequence-stream-restored.png', 1280, 720, false),
  eventPage: image('sequence-stream-event-page', 'interactives/sequence-event-page.png', 512, 512, true),
} as const;

export const SEQUENCE_STREAM_ASSET_LIST = Object.values(SEQUENCE_STREAM_ASSETS);
export const SEQUENCE_STREAM_PRODUCTION_READY = true;

export function preloadSequenceStreamAssets(scene: Phaser.Scene) {
  SEQUENCE_STREAM_ASSET_LIST.forEach(asset => scene.load.image(asset.key, asset.path));
}

export function getMissingSequenceStreamAssets(textures: Phaser.Textures.TextureManager) {
  return SEQUENCE_STREAM_ASSET_LIST.filter(asset => !textures.exists(asset.key));
}

export function canEnterSequenceStream(textures: Phaser.Textures.TextureManager) {
  return SEQUENCE_STREAM_PRODUCTION_READY
    && getMissingSequenceStreamAssets(textures).length === 0;
}
